import { State } from 'src/types'
import { edgeForNormalPocket } from './edge'

export const edgeDrawer = (ctx: CanvasRenderingContext2D, state: State): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = state.catchFace.color

  edgeForNormalPocket(ctx, state.edge.color)
}
